import { render, staticRenderFns } from "./PackageHeader.vue?vue&type=template&id=1e7e86d2&scoped=true&"
import script from "./PackageHeader.vue?vue&type=script&lang=js&"
export * from "./PackageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PackageHeader.vue?vue&type=style&index=0&id=1e7e86d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7e86d2",
  null
  
)

export default component.exports